<template>
  <div>
    <BlocoFiltroPesquisa
      nome-do-form="IndicacaoPorGuiaForm"
      :ordenar-por="['nome']"
      :ordenar-nomes="['Nome']"
      :botao-adicionar="false"
      @pesquisar="pesquisar"
      @ordenar="ordenar"
    >
      <template #form>
        <div class="row">
          <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
            <SelecionarData
              id="dataInicio"
              :valor="filtro.dataInicio"
              :validacao="v$.filtro.dataInicio"
              label="Data Início"
              @atualizar="filtro.dataInicio = $event"
            />
          </div>
          <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
            <SelecionarData
              id="dataFim"
              :valor="filtro.dataFim"
              :validacao="v$.filtro.dataFim"
              label="Data Fim"
              @atualizar="filtro.dataFim = $event"
            />
          </div>
        </div>
      </template>
    </BlocoFiltroPesquisa>
    <br />
    <IndicacaoMedicoTabela
      v-if="indicacoes.length"
      :valores="indicacoes"
      :total="totalIndicacoes"
    />
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import moment from 'moment'

import BlocoFiltroPesquisa from '@/componentes/formulario/BlocoFiltroPesquisa'
import SelecionarData from '@/componentes/formulario/SelecionarData'
import { useMenu } from '@/composables/useMenu'
import MedicoServico from '@/servicos/MedicoServico'
import MensagemServico from '@/servicos/MensagemServico'

import IndicacaoMedicoTabela from './IndicacaoMedicoTabela'
const mensagemServico = new MensagemServico()

export default {
  components: {
    IndicacaoMedicoTabela,
    BlocoFiltroPesquisa,
    SelecionarData,
  },

  setup() {
    useMenu(35)
    return { v$: useVuelidate() }
  },
  data() {
    return {
      solicitantes: [],
      indicacoes: [],
      totalIndicacoes: 0,
      servico: new MedicoServico(),
      nomeResultado: 'indicacoes',
      filtro: {
        dataInicio: moment().startOf('month'),
        dataFim: moment().endOf('month'),
        unidade: '',
        especialidade: '',
        ordenarPor: 'unidade',
      },
    }
  },
  computed: {
    dataInicio() {
      return moment().subtract(1, 'M').format('DD/MM/YYYY')
    },
    dataFim() {
      return moment().format('DD/MM/YYYY')
    },
  },
  validations: {
    filtro: {
      dataInicio: { required },
      dataFim: { required },
    },
  },
  methods: {
    pesquisar() {
      this.v$.$touch()

      if (this.v$.filtro.$invalid) {
        mensagemServico.alerta('Informe a Unidade, Data Início e Data Fim.')
      } else {
        this.servico.relatorioIndicacaoMedico(this.filtro).then((res) => {
          this.indicacoes = res.indicacoes
          this.totalIndicacoes = res.totalIndicacoes
        })
      }
    },
    ordenar(prop) {
      this.filtro.ordenarPor = prop
      this.pesquisar()
    },
  },
}
</script>
